
import { useEffect, useRef } from "react"; 

const GraphCanvas = ({ displayPlayout }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    // Set full width and 80% height
    canvas.width = canvas.parentElement.clientWidth;
    canvas.height = window.innerHeight * 0.8;

    let points = [{ x: 0, y: canvas.height }];

    function updatePoints() {
      let lastPoint = points[points.length - 1];

      // Use `displayPlayout` for X position, ensuring it moves forward only
      let newX = Math.min(displayPlayout, canvas.width - 10); // Prevent going out of bounds
      let newY = canvas.height - (canvas.height * 0.2); // Y is always at 80% height

      if (newX > lastPoint.x) {
        points.push({ x: newX, y: newY });
      }
    }

    function drawGraph() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);

      for (let i = 1; i < points.length - 1; i++) {
        let xc = (points[i].x + points[i + 1].x) / 2;
        let yc = (points[i].y + points[i + 1].y) / 2;
        ctx.quadraticCurveTo(points[i].x, points[i].y, xc, yc);
      }

      ctx.lineTo(points[points.length - 1].x, canvas.height);
      ctx.lineTo(points[0].x, canvas.height);
      ctx.closePath();
      ctx.fillStyle = "rgba(139, 0, 0, 0.6)";
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);

      for (let i = 1; i < points.length - 1; i++) {
        let xc = (points[i].x + points[i + 1].x) / 2;
        let yc = (points[i].y + points[i + 1].y) / 2;
        ctx.quadraticCurveTo(points[i].x, points[i].y, xc, yc);
      }

      ctx.lineWidth = 7;
      ctx.strokeStyle = "red";
      ctx.stroke();
    }

    function animateGraph() {
      updatePoints();
      drawGraph();
      requestAnimationFrame(animateGraph);
    }

    drawGraph();
    setTimeout(animateGraph, 500);
  }, [displayPlayout]); // Re-run when displayPlayout changes

  return <canvas id='graphCanvas'  ref={canvasRef} style={{ width: "100%", height: "80vh", display: "block" }} />;
};

export default GraphCanvas;
